import { LazyImage as CssModulesLazyImage, LazyImageProps } from '@sunwebgroup/uds-ui/lazy-image'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/lazy-image' instead.
 */
const LazyImage = Object.assign(
  styled(CssModulesLazyImage)<LazyImageProps>``,
  { displayName: 'LazyImage' },
)

export default LazyImage
